import { useIntl } from 'react-intl';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

export const LocalizedFilterOptions = (): { [key: string]: string } => {
	const intl = useIntl();

	const gwp7518NavIconUpdates = checkFeatureFlagGate(featureFlags.gwp7518NavIconUpdates);

	return {
		solution: intl.formatMessage({
			id: 'CustomersLandingPage.filterCategory.solution',
			defaultMessage: 'solution',
		}),
		product: gwp7518NavIconUpdates
			? intl.formatMessage({
					id: 'CustomersLandingPage.filterCategory.product-gwp-7518',
					defaultMessage: 'App',
				})
			: intl.formatMessage({
					id: 'CustomersLandingPage.filterCategory.product',
					defaultMessage: 'product',
				}),
		industry: intl.formatMessage({
			id: 'CustomersLandingPage.filterCategory.industry',
			defaultMessage: 'industry',
		}),
		'more filters': intl.formatMessage({
			id: 'CustomersLandingPage.filterCategory.morefilters',
			defaultMessage: 'more filters',
		}),
		'Work Management': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.WorkManagement',
			defaultMessage: 'Work Management',
		}),
		'Agile / DevOps': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.AgileDevOps',
			defaultMessage: 'Agile / DevOps',
		}),
		ITSM: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.ITSM',
			defaultMessage: 'ITSMs',
		}),
		'Cloud Migration': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.CloudMigration',
			defaultMessage: 'Cloud Migration',
		}),
		Jira: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Jira',
			defaultMessage: 'Jira',
		}),
		'Jira Service Management': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.JiraServiceManagement',
			defaultMessage: 'Jira Service Management',
		}),
		'Jira Align': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.JiraAlign',
			defaultMessage: 'Jira Align',
		}),
		'Jira Product Discovery': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.JiraProductDiscovery',
			defaultMessage: 'Jira Product Discovery',
		}),
		Confluence: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Confluence',
			defaultMessage: 'Confluence',
		}),
		Trello: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Trello',
			defaultMessage: 'Trello',
		}),
		Bitbucket: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Bitbucket',
			defaultMessage: 'Bitbucket',
		}),
		Guard: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Guard',
			defaultMessage: 'Guard',
		}),
		Statuspage: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Statuspage',
			defaultMessage: 'Statuspage',
		}),
		Compass: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Compass',
			defaultMessage: 'Compass',
		}),
		Bamboo: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Bamboo',
			defaultMessage: 'Bamboo',
		}),
		Automotive: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Automotive',
			defaultMessage: 'Automotive',
		}),
		Aviation: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Aviation',
			defaultMessage: 'Aviation',
		}),
		'Consumer Goods & Retail': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.ConsumerGoodsRetail',
			defaultMessage: 'Consumer Goods & Retail',
		}),
		Education: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Education',
			defaultMessage: 'Education',
		}),
		'Energy & Utilties': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.EnergyUtilties',
			defaultMessage: 'Energy & Utilties',
		}),
		'Entertainment & Media': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.EntertainmentMedia',
			defaultMessage: 'Entertainment & Media',
		}),
		'Financial Services': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.FinancialServices',
			defaultMessage: 'Financial Services',
		}),
		Government: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Government',
			defaultMessage: 'Government',
		}),
		'Healthcare & Life Sciences': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.HealthcareLifeSciences',
			defaultMessage: 'Healthcare & Life Sciences',
		}),
		'Internet & Telecommunications': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.InternetTelecommunications',
			defaultMessage: 'Internet & Telecommunications',
		}),
		Manufacturing: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Manufacturing',
			defaultMessage: 'Manufacturing',
		}),
		'Non-Profit': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.NonProfit',
			defaultMessage: 'Non-Profit',
		}),
		'Real Estate': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.RealEstate',
			defaultMessage: 'Real Estate',
		}),
		Software: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Software',
			defaultMessage: 'Software',
		}),
		Technology: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Technology',
			defaultMessage: 'Technology',
		}),
		'Marketplace apps': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.MarketplaceApps',
			defaultMessage: 'Marketplace apps',
		}),
		'Only show stories from customers that use marketplace apps': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.MarketplaceApps.description',
			defaultMessage: 'Only show stories from customers that use Marketplace apps',
		}),
		'Solution partner': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.SolutionPartner',
			defaultMessage: 'Solution partner',
		}),
		'Only show stories from customers that have a solution partner': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.SolutionPartner.description',
			defaultMessage: 'Only show stories from customers that have a Solution Partner',
		}),
		Americas: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Americas',
			defaultMessage: 'Americas',
		}),
		'Europe, Middle East, Africa': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.EuropeMiddleEastAfrica',
			defaultMessage: 'Europe, Middle East, Africa',
		}),
		'Asia Pacific': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.AsiaPacific',
			defaultMessage: 'Asia Pacific',
		}),
		Global: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Global',
			defaultMessage: 'Global',
		}),
		'Small/Medium Business': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.SmallMediumBusiness',
			defaultMessage: 'Small/Medium Business',
		}),
		Enterprise: intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.Enterprise',
			defaultMessage: 'Enterprise',
		}),
		'Large Enterprise': intl.formatMessage({
			id: 'CustomersLandingPage.subFilter.LargeEnterprise',
			defaultMessage: 'Large Enterprise',
		}),
	};
};
